import React, { FC } from 'react';
import { formatDate } from '@investoro/core';
import styled from 'styled-components';

import { BoxContainer } from 'components/common/BoxContainer';

const TableWrapper = styled.div`
    padding: 50px;
    display: flex;
    justify-content: center;
`;

const Table = styled.table`
    border-collapse: collapse;
    min-width: 400px;
`;

const SectionHeaderRow = styled.tr`
    font-weight: 600;
    text-align: center;
    background-color: var(--color-alt-second);
`;

const TableRow = styled.tr<{ isGray?: boolean }>`
    background-color: ${(props) => props.isGray ? 'var(--color-white)' : 'var(--color-alt-second)'};
`;

const TableCell = styled.td<{ alignCenter?: boolean }>`
    padding: 10px 20px;
    border: none;
    text-align: ${({ alignCenter }) => alignCenter ? 'center' : 'left'};
`;

export interface RaisesValue {
  date?: string;
}

export type RaisesTabContentProps = RaisesValue[];

const RaisesTab: FC<{ raisesValues?: RaisesValue[] }> = ({ raisesValues }) => {
    return (

        <BoxContainer>
            <TableWrapper>
                <Table>
                    <thead>
                        <SectionHeaderRow>
                            <TableCell alignCenter>Daty</TableCell>
                        </SectionHeaderRow>
                    </thead>
                    <tbody>
                        {raisesValues && raisesValues.length > 0
                            ? raisesValues.map((el, index) => <TableRow key={index} isGray={index % 2 === 0}>
                                <TableCell alignCenter>{formatDate(el.date!)}</TableCell>
                            </TableRow>)
                            : null}
                    </tbody>
                </Table>
            </TableWrapper>
        </BoxContainer>

    );
};

export default RaisesTab;

